// eslint-disable-next-line jira/filename-case, jira/restricted/@atlassian/react-sweet-state
import { createStateHook, type HookStateFunction } from '@atlassian/react-sweet-state';
import { NavigationCollectionsStore } from './useNavigationCollectionsActions.tsx';
import type { NavigationCollection } from './NavigationCollection.types.tsx';
import {
	getCollectionsData,
	getCollectionsDataCount,
	getCollectionsError,
	getCollectionsInitialized,
	getCollectionsIsLoading,
} from './getCollectionsData.tsx';

export const useCollectionsInitialized: HookStateFunction<boolean, void> = createStateHook(
	NavigationCollectionsStore,
	{
		selector: getCollectionsInitialized,
	},
);

export const useCollectionsIsLoading: HookStateFunction<boolean, void> = createStateHook(
	NavigationCollectionsStore,
	{
		selector: getCollectionsIsLoading,
	},
);

export const useCollectionsError: HookStateFunction<Error | null, void> = createStateHook(
	NavigationCollectionsStore,
	{
		selector: getCollectionsError,
	},
);

export const useCollectionsData: HookStateFunction<NavigationCollection[], void> = createStateHook(
	NavigationCollectionsStore,
	{
		selector: getCollectionsData,
	},
);

export const useCollectionsDataCount: HookStateFunction<number, void> = createStateHook(
	NavigationCollectionsStore,
	{
		selector: getCollectionsDataCount,
	},
);
